import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css';
import './styles/brand-theme.css';
import './styles/mobile-optimizations.css';
import './styles/design-system.css'
import './styles/animations.css'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient'
import { ClerkProvider } from '@clerk/clerk-react'
import ClerkErrorBoundary from './components/ClerkErrorBoundary'


const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY?.trim();

if (!PUBLISHABLE_KEY || !PUBLISHABLE_KEY.startsWith('pk_')) {
  throw new Error("Missing or invalid Clerk Publishable Key");
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkErrorBoundary>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        afterSignOutUrl="/"
        signInFallbackRedirectUrl="/dashboard"
        signUpFallbackRedirectUrl="/onboarding"
        appearance={{
          baseTheme: undefined,
          variables: {
            colorPrimary: '#2563eb'
          }
        }}
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ClerkProvider>
    </ClerkErrorBoundary>
  </React.StrictMode>,
)
